import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {CommonService} from 'src/app/shared/utils/common.service';
import {moduloHorasExtras} from "../diccionarios/horas-extrasModulo";

@Injectable({
  providedIn: 'root'
})
export class HorasExtrasTurnosService {

  diccionarioModulo: any;
  url: string;

  constructor(
    private http: HttpClient,
    private _util: UtilsService,
    private _commom: CommonService
  ) {
    this.diccionarioModulo = moduloHorasExtras;
    this.url = this._util.getUrlHorasExtra();
  }

  getAllDepartment() {
    return this._commom.peticionGetConHeader(`${this.url}${this.diccionarioModulo.url.horasExtras.modificacionMarcacion.getAllDepartment}`);
  }

  getAll(payload) {
    return this._commom.peticionGetConHeader(`${this.url}${this.diccionarioModulo.url.horasExtras.cargaTurno.getAll}${payload.year}/${payload.week}?departamento=${payload.department}`);
  }

  getAllRango(payload) {
    return this._commom.peticionGetConHeader(`${this.url}${this.diccionarioModulo.url.horasExtras.cargaTurno.getAll}${payload.startDate}/${payload.endDate}?departamento=${payload.department}`);
  }

  loadShifts(payload, file) {
    return this._commom.peticionPostConHeader(`${this.url}${this.diccionarioModulo.url.horasExtras.cargaTurno.loadShifts}${payload.year}/${payload.week}?departamento=${payload.department}`, file);
  }
}
